import { EachDiv } from './EachStyles.styles';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import React, { Suspense } from 'react';
const SecondaryButton = React.lazy(
  () => import('../Buttons/SecondaryButton/SecondaryButton.component')
);

// For Editing a Single Entity
const EachComponent = React.memo(
  ({ key = '', name = '', route = '', id = '', buttonSpan = 'Edit' }) => {
    const navigate = useNavigate();

    const editItem = (e) => {
      e.preventDefault();
      navigate(route);
    };

    return (
      <EachDiv key={id}>
        <h4 key={key}>{name?.slice(0, 40)}</h4>
        <Suspense fallback={<div>Loading button...</div>}>
          <SecondaryButton functionName={editItem} span={buttonSpan} />
        </Suspense>
      </EachDiv>
    );
  }
);
EachComponent.displayName = 'Each Component';

EachComponent.propTypes = {
  key: PropTypes.string,
  name: PropTypes.string,
  route: PropTypes.string,
  id: PropTypes.string,
  buttonSpan: PropTypes.string,
};

export default EachComponent;
